<template>
  <div class="col-lg-6">
    <div class="m-t">
      <div class="bg-muted p-xs b-r-sm document document-green">
        <div class="row">
          <div class="col-lg-6 document-title">
            <span>{{ document.title }}</span>
          </div>
          <div class="text-right m-r">
            <div class="tooltip-demo">
              <button
                @click="fetchDocument()"
                class="btn btn-default btn-circle"
                v-tooltip.top-center="'Visualiser'"
              >
                <i class="fa fa-eye"></i>
              </button>
              <button
                @click="downloadDocument()"
                class="btn btn-default btn-circle"
                v-tooltip.top-center="'Télécharger'"
              >
                  <i class="fa fa-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
    components: {},
    props: {
        document: {
            type: Object,
            required: true
        }
    },
    data: () => ({}),
    computed: {},
    mounted () {},
    methods: {
        async fetchDocument() {
          this.showFileViewer({
            image: this.document.url
          });
        },
        async downloadDocument() {
            let fileName = this.document.fileName;
            fetch(this.document.url).then(function(file) {
                return file.blob().then((blob)=>{
                    var a = document.createElement("a");
                    a.href = URL.createObjectURL(blob);
                    a.setAttribute("download", fileName);
                    a.click();
                    a.delete();
                });
            });
        }
    }
  }
</script>

<style>
  .fa-download {
    margin-left: 8px;
    margin-right: 12px;
  }
  button {
    margin-left: 5px;
  }
</style>
